module.exports = __webpack_public_path__ + "img/slide-3.79f88bc9.png";